import { useState } from 'react'
import Globe02 from '@untitled-ui/icons-react/build/esm/Globe02'

interface HeaderProps {
	website?: any | null
	size?: number
	src?: string | null
	name?: string | null
	demoMode?: boolean
}

export const WebsiteAvatar = ({
	website,
	size,
	src,
	name,
	demoMode
}: HeaderProps) => {
	const [failed, setFailed] = useState(false)

	const getAvatar = () => {
		if (website?.name?.length > 0) {
			return `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&url=http://${website?.name.replace(
				/http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g,
				''
			)}&size=32`
		}
	}

	if (demoMode) {
		return (
			<img
				className={`inline-block h-${size || 10} w-${size || 10} rounded-full`}
				src={'https://eu.ui-avatars.com/api/?name=Demo PPC account'}
				alt="website icon"
				onError={(e) =>
					(e.currentTarget.src =
						'https://eu.ui-avatars.com/api/?name=	Demo PPC account')
				}
			/>
		)
	}

	const uploadedSrc = src || website?.avatar
	const imgSrc = uploadedSrc || getAvatar()

	if (failed || !imgSrc) {
		return (
			<Globe02
				className={`inline-block h-${size || 10} w-${size || 10} text-[var(--text-secondary,#535255)]`}
			/>
		)
	}

	return (
		<img
			className={`inline-block h-${size || 10} w-${size || 10} rounded-full`}
			src={imgSrc}
			alt="website icon"
			onError={() => setFailed(true)}
			onLoad={(e) => {
				if (!uploadedSrc && e.currentTarget.naturalWidth < 32) {
					setFailed(true)
				}
			}}
		/>
	)
}
